export const HITS_PER_PAGE = 32
export const HITS_PER_PAGE_WITH_BUYBACK = 31
